import React from 'react';
import apiConfig from '../config/api';
import {
  clearImpersonationSession,
  getEffectiveToken,
  getEffectiveUser,
  getImpersonationMeta,
  isImpersonating
} from '../utils/authSession';

const ImpersonationBanner = () => {
  const active = isImpersonating();
  const meta = getImpersonationMeta();
  const effectiveUser = getEffectiveUser();
  const isTeacherView = effectiveUser ? !effectiveUser.isAdmin : false;

  if (!active || !meta?.domain) return null;

  const isSuperAdminActor = meta.actorRole === 'super_admin' || (meta.returnLabel || '').toLowerCase() === 'superadmin';
  const isAdminActor = meta.actorRole === 'admin' || (meta.returnLabel || '').toLowerCase() === 'admin';
  const bannerPrefix = isSuperAdminActor ? 'Logged in as' : 'Viewing Policy Details for';
  const returnLabel = meta.returnLabel || 'Superadmin';
  const returnPath = meta.returnPath || '/admin/domains';

  const formatNameLastFirst = (name?: string) => {
    const trimmed = (name || '').trim();
    if (!trimmed) return '';
    const parts = trimmed.split(/\s+/).filter(Boolean);
    if (parts.length < 2) return trimmed;
    const last = parts[parts.length - 1];
    const first = parts.slice(0, -1).join(' ');
    return `${last}, ${first}`;
  };

  const teacherNameLabel = formatNameLastFirst(meta.targetName || effectiveUser?.name);
  const contextLabel = isAdminActor && isTeacherView
    ? (teacherNameLabel || meta.targetEmail || meta.domain)
    : (isTeacherView && meta.targetEmail ? meta.targetEmail : meta.domain);

  const handleReturn = async () => {
    try {
      const token = getEffectiveToken();
      const baseUrl = String(apiConfig.API_BASE_URL || '').replace(/\/$/, '');
      if (token && baseUrl) {
        await fetch(`${baseUrl}/admin/impersonation/revoke`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: '{}'
        }).catch(() => {});
      }
    } finally {
      clearImpersonationSession();
      const separator = returnPath.includes('?') ? '&' : '?';
      const targetUrl = `${window.location.origin}${window.location.pathname}#${returnPath}${separator}impersonationReturn=${Date.now()}`;
      window.location.replace(targetUrl);
    }
  };

  return (
    <>
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 4000,
          padding: '10px 14px',
          backgroundColor: '#fee',
          borderBottom: '1px solid #fcc',
          color: '#c00',
          fontWeight: 700,
          textAlign: 'center'
        }}
      >
        {bannerPrefix} {contextLabel}{' '}
        <button
          type="button"
          onClick={handleReturn}
          style={{
            border: 'none',
            background: 'transparent',
            color: '#1d4ed8',
            textDecoration: 'underline',
            fontWeight: 800,
            cursor: 'pointer',
            padding: 0
          }}
        >
          Return to {returnLabel}
        </button>
      </div>
      <div aria-hidden="true" style={{ height: '46px' }} />
    </>
  );
};

export default ImpersonationBanner;
